import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
} from '../../components';
import { employeeStore, userStore, walletStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import React from 'react';

const SubwalletInfo = ({
	closeModal,
	settings,
	showSettings,
	onSubmit,
	validationSchema,
	loading,
	assignEmployee,
	showAssignEmployee,
	userValidationSchema,
	onSubmitAssign,
	goBack,
	removeSubwallet,
}) => {
	const { selectedSubWallet } = walletStore;
	const { businessAdmins } = employeeStore;
	const admins = businessAdmins.map(admin => {
		return {
			key: admin.user?._id,
			value: `${admin.user?.firstname} ${admin.user?.lastname}`,
		};
	});
	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText align="center" variant="subtitle" mb={4} width={38}>
				{selectedSubWallet.name}
			</MimaText>

			{!settings && !assignEmployee && (
				<>
					<MimaText labelTitle="Sub-wallet Name" mb={2} width={38}>
						{selectedSubWallet.name}
					</MimaText>
					<MimaText labelTitle="Assigned Employees" mb={2} width={38}>
						{selectedSubWallet.users?.map(user => (
							<MimaText mb={2} width={38}>
								{`${user.firstname} ${user.lastname}`}
							</MimaText>
						))}
					</MimaText>
					<MimaText labelTitle="Sub-wallet Limit" mb={2} width={38}>
						{amountFormatter().format(selectedSubWallet.limit)}
					</MimaText>
					<MimaText labelTitle="Sub-wallet Balance" mb={2} width={38}>
						{amountFormatter().format(selectedSubWallet.balance)}
					</MimaText>
					<MimaText labelTitle="Sub-wallet Previous Balance" mb={2} width={38}>
						{amountFormatter().format(selectedSubWallet.previousBalance)}
					</MimaText>
					<MimaText labelTitle="Period" mb={2} width={38}>
						{selectedSubWallet.limitPeriod}
					</MimaText>

					{permissions.has('CAN CREATE/UPDATE PETTY CASH BALANCE') && (
						<div className="modal__beside">
							<MimaButton
								title="Edit Petty Cash Wallet"
								width={18}
								variant="filter"
								onClick={showSettings}
								buttonColor="var(--color-primary)"
								mr={2}
							/>
							<MimaButton
								title="Assign To Employee"
								width={20}
								onClick={showAssignEmployee}
								variant="filter"
							/>
						</div>
					)}
					{permissions.has('CAN DEACTIVATE PETTY CASH BALANCE') && (
						<MimaButton
							title="Deactivate Sub Wallet"
							mt={2}
							width={25}
							variant="filter"
							buttonColor="var(--color-error)"
							onClick={() => {
								removeSubwallet(selectedSubWallet._id);
							}}
						/>
					)}
				</>
			)}
			{assignEmployee && (
				<Formik
					initialValues={{
						user: '',
						action: '',
					}}
					validationSchema={userValidationSchema}
					onSubmit={onSubmitAssign}
				>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<div>
							<MimaDropdown
								labelTitle="Action"
								name="action"
								placeholder="Select Action"
								value={values.action}
								id="action"
								onChange={data => {
									setFieldValue('action', data.key);
								}}
								data={[
									{
										key: 'ADD',
										value: 'ADD',
									},
									{
										key: 'REMOVE',
										value: 'REMOVE',
									},
								]}
								touched={touched.action}
								error={errors.action}
							/>
							<MimaDropdown
								labelTitle="Admins"
								name="action"
								placeholder="Select Admin"
								value={values.user}
								id="user"
								onChange={data => {
									setFieldValue('user', data.key);
								}}
								data={admins}
								touched={touched.user}
								error={errors.user}
							/>

							<MimaButton
								title="Save"
								loading={loading}
								type="submit"
								onClick={handleSubmit}
							/>
						</div>
					)}
				</Formik>
			)}
			{settings && (
				<Formik
					initialValues={{
						name: selectedSubWallet.name,
						limit: selectedSubWallet.limit,
						limitPeriod: selectedSubWallet.limitPeriod,
					}}
					validationSchema={validationSchema}
					onSubmit={onSubmit}
				>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<div>
							<MimaInput
								type="text"
								labelTitle="Name of Petty Cash"
								placeholder="e.g Petty Cash 1"
								name="name"
								mb={2}
								value={values.name}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.name}
								touched={touched.name}
							/>

							<MimaInput
								type="text"
								labelTitle="Limit"
								placeholder=""
								name="limit"
								mb={2}
								value={values.limit}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.limit}
								touched={touched.limit}
							/>

							<MimaDropdown
								labelTitle="Period"
								placeholder={selectedSubWallet.limitPeriod}
								currentValue={values.limitPeriod}
								name="limitPeriod"
								value={values.limitPeriod}
								id="customerGroup"
								onChange={data => {
									setFieldValue('limitPeriod', data.key);
								}}
								data={[
									{
										key: 'DAILY',
										value: 'DAILY',
									},
									{
										key: 'WEEKLY',
										value: 'WEEKLY',
									},
									{
										key: 'MONTHLY',
										value: 'MONTHLY',
									},
									{
										key: 'YEARLY',
										value: 'YEARLY',
									},
								]}
								touched={touched.limitPeriod}
								error={errors.limitPeriod}
							/>

							<MimaButton
								title="Save"
								loading={loading}
								type="submit"
								onClick={handleSubmit}
							/>
						</div>
					)}
				</Formik>
			)}
		</Modal>
	);
};

export default SubwalletInfo;
